export const is: (a: unknown) => a is unknown[] | readonly unknown[] = Array.isArray
